/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';
import { rowErrorSchema } from './rowErrorSchema';

export const teamCsvValidationErrorBodySchema = z.object({
  get errors() {
    return z.array(rowErrorSchema);
  },
  jobId: z.int(),
  phase: z.string(),
});
